import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useGetDtsRelations, type DtsRelationDto } from '@dhl/mdp-api'
import { Autocomplete, Stack, StackRow } from '@dhl-ui/components'
import { PppRelation } from '~/modules/ppp/submodules/relations/components'
import { useCanViewPpp } from '~/modules/ppp/hooks'

export const PppRelationsPage = () => {
  const canAccess = useCanViewPpp()
  const { data: relations, isSuccess } = useGetDtsRelations()
  const [selectedRelation, setSelectedRelation] = useState<DtsRelationDto | undefined>(undefined)
  const { t } = useTranslation()

  if (!canAccess || !isSuccess) {
    return null
  }

  const relationsOptions = relations.map((relation) => ({ label: relation.name, value: relation.id }))
  return (
    <Stack>
      <StackRow>
        <Autocomplete
          data-testid="ppp-relations-autocomplete"
          fullWidth
          options={relationsOptions}
          placeholder={t('admin.pppRelationsPage.search.placeholder')}
          onChange={(_, value) => {
            setSelectedRelation(relations.find((relation) => relation.id === value?.value))
          }}
        />
      </StackRow>
      {selectedRelation && <PppRelation relation={selectedRelation} />}
    </Stack>
  )
}
